import { useState } from 'react';
import { ModalContext } from '../context/modal';

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {React.JSX.Element}
 */
export const ModalProvider = ({ children }) => {
  const [activeModalId, setActiveModalId] = useState(/** @type {string | null} */ (null));

  return <ModalContext.Provider value={{ activeModalId, setActiveModalId }}>{children}</ModalContext.Provider>;
};
